import { EffectCallback, useEffect } from 'react';

export const useEffectOnMount = (effect: EffectCallback) => {
  useEffect(() => {
    effect();
  }, []);
};
